import { render, staticRenderFns } from "./ContactDistributions.vue?vue&type=template&id=5f2980ce&scoped=true"
import script from "./ContactDistributions.vue?vue&type=script&lang=js"
export * from "./ContactDistributions.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributions.vue?vue&type=style&index=0&id=5f2980ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2980ce",
  null
  
)

export default component.exports